
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tinder",
      function () {
        return require("private-next-pages/tinder/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tinder"])
      });
    }
  